export default __webpack_public_path__ + "static/media/browserconfig.89bfad8a.xml";